import { fetchData } from 'modules/Axios';
import { notifyFailure } from 'modules/Notifications';

export const defaultState = {
  liveboardId: null,
  maxDateOffset: { value: 2, unit: 'days' },
  minDateOffset: { value: 6, unit: 'weeks' },
  visibleTabs: null,
  visibleVizs: null,
};

const SET_OPERATIONAL_DASH_CONFIG = 'SET_OPERATIONAL_DASH_CONFIG';
const setOperationalDashConfig = (config) => ({
  type: SET_OPERATIONAL_DASH_CONFIG,
  payload: config,
});

export const getOperationalDashConfig = () => {
  return async (dispatch, getState) => {
    try {
      const { brand: { id } } = getState().app;
      const url = `/brands/${id}/properties/Operational-Dashboard`;
      const config = await dispatch(fetchData(url));
      if (!config.liveboardId) throw new Error('Invalid dashboard config');
      return dispatch(setOperationalDashConfig(config));
    } catch (e) {
      if (e.message !== 'CANCEL_DATA_REQUEST') {
        console.error('Failed to get valid Operational Dashboard config...', e);
        notifyFailure('Error retrieving Operational Dashboard configuration. Please contact your Customer Partner if the issue persists.', 8000);
      }
      return dispatch(resetOperationalDash());
    }
  };
};

const RESET_OPERATIONAL_DASH = 'RESET_OPERATIONAL_DASH';
export const resetOperationalDash = () => ({
  type: RESET_OPERATIONAL_DASH,
});

export default function reducer(state = defaultState, action = {}) {
  switch (action.type) {
    case SET_OPERATIONAL_DASH_CONFIG: {
      const {
        liveboardId = defaultState.liveboardId,
        visibleTabs = defaultState.visibleTabs,
        visibleVizs = defaultState.visibleVizs,
        minDateOffset = defaultState.minDateOffset,
        maxDateOffset = defaultState.maxDateOffset,
      } = action?.payload ?? {};
      return {
        ...state,
        liveboardId,
        visibleTabs,
        visibleVizs,
        minDateOffset,
        maxDateOffset,
      };
    }
    case RESET_OPERATIONAL_DASH:
      return {
        ...state,
        liveboardId: defaultState.liveboardId,
        visibleTabs: defaultState.visibleTabs,
        visibleVizs: defaultState.visibleVizs,
        minDateOffset: defaultState.minDateOffset,
        maxDateOffset: defaultState.maxDateOffset,
      };
    default:
      return state;
  }
}
